import { ISprintWords } from '../../../textbook/types';
import { SprintAction, SprintActionTypes } from '../type';

interface sprintState {
  words: ISprintWords[];
  group: number;
}

const initialState: sprintState = {
  words: [],
  group: -1,
};

export const sprintReducer = (state = initialState, action: SprintAction) => {
  switch (action.type) {
    case SprintActionTypes.FETCH_SPRINT_WORDS:
      return {
        ...state,
        words: action.payload,
      };
    case SprintActionTypes.UPDATE_GROUP:
      return {
        ...state,
        group: action.payload,
      };
    case SprintActionTypes.UPDATE_WORDS_SPRINT:
      return {
        ...state,
        words: action.payload,
      };
    case SprintActionTypes.REMOVE_WORDS:
      return { ...state, words: [] };
    default:
      return state;
  }
};
